import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _Input from "antd/es/input";
import React, { useEffect } from 'react';
import { css, cx } from 'emotion';
import IconFont from '@/components/common/IconFont';
var TextArea = _Input.TextArea;
export default (function (props) {
  var className = props.className,
    restProps = _objectWithoutProperties(props, ["className"]);
  var _restProps$required = restProps.required,
    required = _restProps$required === void 0 ? false : _restProps$required,
    _restProps$value = restProps.value,
    value = _restProps$value === void 0 ? '' : _restProps$value,
    _restProps$maxwords = restProps.maxwords,
    maxwords = _restProps$maxwords === void 0 ? 50 : _restProps$maxwords,
    _restProps$chosen = restProps.chosen,
    chosen = _restProps$chosen === void 0 ? false : _restProps$chosen,
    id = restProps.id;
  useEffect(function () {
    var input = document.querySelector("#".concat(id));
    if (!window.isReport && chosen && input) {
      window.requestAnimationFrame(function () {
        var length = input.value.length;
        input.selectionStart = length;
        input.selectionEnd = length;
        input.focus();
      });
    }
  }, [chosen]);
  return React.createElement(React.Fragment, null, required && !value.length && React.createElement(IconFont, {
    type: "icon-icon-test",
    className: requiredIcon
  }), React.createElement(TextArea, _extends({}, restProps, {
    className: cx(className, autoHeightText),
    autoSize: true,
    id: id
  })), maxwords > 0 && React.createElement("div", {
    className: cx(countCls)
  }, value.length, " / ", maxwords));
});
var requiredIcon = /*#__PURE__*/css("position:absolute;left:46px;top:36px;z-index:999;font-size:7px;");
var autoHeightText = /*#__PURE__*/css("padding:16px 11px !important;background:var(--am-entity-bg) !important;outline:none;border:none !important;margin:10px 0 !important;&:focus{border:1px solid var(--primary-color) !important;}.has-error &:focus{border:none !important;}");
var countCls = /*#__PURE__*/css("font-size:12px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:0.2px;text-align:right;color:var(--text-color-secondary);position:absolute;bottom:7px;right:16px;");